import React, { useState, useEffect } from 'react'
import { Map, Marker, TileLayer, Tooltip } from 'react-leaflet'

const defaultProps = {
  isAdmin: true,
  deliveries: null,
  locks: null,
}

type Props = {
  isAdmin?: Boolean,
  deliveries?: [],
  locks?: [],
}

const getCoordinates = ({ address: { coordinates } }) => (coordinates && coordinates.latitude && coordinates.longitude ? [coordinates.latitude, coordinates.longitude] : [])

const ExploringMap = ({ isAdmin, locks, deliveries, selectLock }: Props) => {
  const [displayedLocks, setDisplayedLocks] = useState([])

  useEffect(() => {
    setDisplayedLocks(isAdmin ? locks.filter((l) => (l.sub_type === 'container' && l.address && l.address.coordinates) || deliveries.some((d) => d.to_lock === l._id)) : locks)
  }, [isAdmin, locks])

  const bounds = displayedLocks.map(getCoordinates).filter((b) => b.length === 2)

  if (bounds.length === 0) return null

  return (
    <Map bounds={bounds} zoom={12}>
      <TileLayer id="mapbox.streets" url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" maxZoom={18} crossOrigin attribution='&copy; <a href="https://www.mapbox.com">OpenStreetMap</a> contributors' />
      {displayedLocks.map((l) => {
        const position = getCoordinates(l)

        if (!position[0] || !position[1] || position.length === 0) return null

        return (
          <Marker key={l._id} position={position} onclick={() => selectLock(l._id)}>
            <Tooltip>{l.custom_name}</Tooltip>
          </Marker>
        )
      })}
    </Map>
  )
}

ExploringMap.defaultProps = defaultProps

export default React.memo(ExploringMap)
